<template>
  <div class='config-text-row'>
    <span class='config-text-row__plan'>{{title}}</span>
    <span class='config-text-row__value'>{{value}}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String
  }
}
</script>

<style lang='scss'>
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-capacity-config-row__capacity .config-text-row {
  margin: 0;
  padding: 0;
  min-width: 136px;
  color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  font-size: 16px;
  height: 100%;

  @include media(mobile) {
    margin: 0;
    padding: 0;
  }
}
.config-text-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  @include media(mobile) {
    margin: 0;
    padding: 0;
  }

  &__plan {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  &__value {
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 150%;
    display: inline-flex;
    align-items: center;
    flex: 1;
  }
}
</style>
